export enum CacheStorageNames {
    Api = "api",
    Assets = "assets",
    Offline = "offline",
    Metadata = "metadata",
    Search = "search",
}
